import { render, staticRenderFns } from "./reply-quote.vue?vue&type=template&id=553468b6&scoped=true&"
import script from "./reply-quote.vue?vue&type=script&lang=js&"
export * from "./reply-quote.vue?vue&type=script&lang=js&"
import style0 from "./reply-quote.vue?vue&type=style&index=0&id=553468b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553468b6",
  null
  
)

export default component.exports